export enum OrderSources {
  doordash = 'DOORDASH',
  ubereats = 'UBEREATS',
  postmates = 'POSTMATES',
  'consumer-api' = 'CONSUMER-API',
  'ubereats-spi' = 'UBEREATS-SPI',
  glovo = 'GLOVO',
  rappi = 'RAPPI',
  'rappi-xl' = 'RAPPI-XL',
  'rappi-turbo' = 'RAPPI-TURBO',
  grubhub = 'GRUBHUB',
  jet = 'JET',
  foodpanda = 'FOODFANDA',
  pedidosya = 'PEDIDOSYA',
  justeat = 'JUSTEAT',
  hugo = 'HUGO',
  skipthedishes = 'SKIPTHEDISHES',
  deliveroo = 'DELIVEROO',
  menulog = 'MENULOG',
  takeaway = 'TAKEAWAY',
  didi = 'DIDI',
  'didi-xl' = 'DIDI-XL',
}

export enum OrderProcessingStatus {
  placed = 'placed',
  kitchen = 'kitchen',
  ready = 'ready',
  completed = 'completed',
  failed = 'failed',
  canceled = 'canceled',
}

export enum OrderProcessingStatusConsumerDescription {
  placed = 'Order placed',
  kitchen = 'Order sent to Kitchen',
  ready = 'Order Ready',
  completed = 'Order Completed',
  failed = 'Order Failed',
  canceled = 'Order Canceled',
}

export const CANCELABLE_AGGREGATOR_CHANNELS: readonly string[] = [
  OrderSources.doordash,
  OrderSources.ubereats,
];
